import axios from "./abstract.service";

export const fetchNews = (params: any): any => {
  return axios.get("news", { params }).then((res) => res);
};

export const fetchNewsDetail = (id: string | number): any => {
  return axios
    .get(`news/${id}`) // Đảm bảo gọi đúng endpoint với id bài viết
    .then((res) => res.data); // Trả về dữ liệu từ response
};

const newsService = {
  fetchNews,
  fetchNewsDetail,
};

export default newsService;
